import request from '@/utils/request'

export function getHostInformation(data) {
    return request({
        url: 'agent_admin/hotchat/host/list',
        method: 'post',
        data
    })
}